import { FC, useEffect, useState } from "react";
import { Button as ButtonComponent, Collapse, Table } from "reactstrap";
import { AccordionCollapsePaymentProps } from "./AccordionCollapse.constants";
import { formatDecimal } from "../../utils/formatText";
import { useCustomerPaymentInstallmentAddMutation } from "../../../modules/CustomerProfile/CustomerProfile.actions";
import { RESPONSE_CODE } from "../../models/Types";
import { successNotify } from "../../utils/notifications";
import { getItem } from "../../hooks/useCookie";
import { paymentFormatter } from "../../../modules/CustomerProfile/CustomerProfile.constants";

const AccordionCollapsePayment: FC<AccordionCollapsePaymentProps> = ({
  accordionList,
  toggle,
  mutate,
}) => {
  const customerProfileId = getItem("customerProfileId");

  const { data: customerPaidOrderData, mutate: customerPaidOrderMutation } =
    useCustomerPaymentInstallmentAddMutation();

  const [selectedCollapse, setSelectedCollapse] = useState<any>();

  const onSelectAccordionHandler = (index: number) => {
    setSelectedCollapse(index);
  };

  useEffect(() => {
    const filterIndex = accordionList?.results.filter(
      (payment) => payment.is_paid !== false
    );
    setSelectedCollapse(filterIndex && filterIndex?.length - 1);
  }, [accordionList]);

  useEffect(() => {
    if (customerPaidOrderData?.status === RESPONSE_CODE.SUCCESS_CODE) {
      successNotify("Ödeme silme başarılı");

      mutate({ id: customerProfileId });

      toggle();
    }
  }, [customerPaidOrderData]);

  const paymentCancelHandler = (id: number) => {
    customerPaidOrderMutation({
      paymentId: id,
      payment_type: 1,
      is_paid: false,
    });
  };

  return (
    <div className="accordion accordion-flush" id="accordionFlushExample">
      {accordionList?.results
        .filter((payment) => payment.is_paid !== false)
        .reverse()
        .map((accordionItem, index) => {
          return (
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingFlushOne">
                <button
                  className={`accordion-button fw-medium ${
                    selectedCollapse === index ? "collapsed" : ""
                  }`}
                  type="button"
                  onClick={() =>
                    onSelectAccordionHandler(
                      selectedCollapse === index ? -1 : index
                    )
                  }
                  style={{ cursor: "pointer" }}
                >
                  {"Ödeme " + (index + 1)}
                </button>
              </h2>
              <Collapse
                isOpen={index === selectedCollapse}
                className="accordion-collapse"
              >
                <div style={{ padding: 0 }} className="accordion-body">
                  <div className="border rounded">
                    <div className="table-responsive">
                      <Table className="table-nowrap align-middle mb-0">
                        <tbody>
                          <tr
                            style={{ backgroundColor: "#2C302E" }}
                            key={"key"}
                          >
                            <h5 className="font-size-15 mb-1">
                              {"Ödenen Miktar"}
                            </h5>
                            <td></td>
                            <td className="text-end">
                              {formatDecimal(accordionItem?.amount)} TL
                            </td>
                          </tr>

                          <tr key={"key"}>
                            <h5 className="font-size-15 mb-1">
                              {"Ödeme Tarihi"}
                            </h5>
                            <td></td>
                            <td
                              style={{ whiteSpace: "normal" }}
                              className="text-end "
                            >
                              {accordionItem?.paid_date !== null
                                ? accordionItem?.paid_date.split("T")[0]
                                : "Ödeme yok"}
                            </td>
                          </tr>

                          <tr key={"key"}>
                            <h5 className="font-size-15 mb-1">{"Not"}</h5>
                            <td></td>
                            <td className="text-end">{accordionItem?.note}</td>
                          </tr>

                          <tr key={"key"}>
                            <h5 className="font-size-15 mb-1">
                              {"Ödeme Tipi"}
                            </h5>
                            <td></td>
                            <td className="text-end">
                              {paymentFormatter(accordionItem?.payment_type)}
                            </td>
                          </tr>

                          <tr key={"key"}>
                            <h5 className="font-size-15 mb-1">
                              {"Ödemeyi Alan"}
                            </h5>
                            <td></td>
                            <td className="text-end">
                              {accordionItem?.person_who_created?.fullname}
                            </td>
                          </tr>

                          <tr key={"key"}>
                            <h5 className="font-size-15 mb-1">{"Durum"}</h5>
                            <td></td>
                            <td className="text-end">
                              {!!accordionItem?.is_paid ? "Ödendi" : "Ödenmedi"}
                            </td>
                          </tr>

                          {accordionItem.payment_type === "ap" && (
                            <tr key={"key"}>
                              <h5 className="font-size-15 mb-1">{"İşlem"}</h5>
                              <td></td>
                              <td className="text-end">
                                <span
                                  style={{ marginLeft: 9 }}
                                  onClick={() => {
                                    paymentCancelHandler(accordionItem?.id);
                                  }}
                                  className="badge btn btn-danger rounded-pill font-size-10 p-2 pointer"
                                >
                                  <i className="mdi mdi-border-color noti-icon"></i>{" "}
                                  Ödemeyi İptal et
                                </span>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          );
        })}
    </div>
  );
};

export default AccordionCollapsePayment;
